import React, { useState, useEffect } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';
import '../Styles/VoidStats.css';

function VoidStats() {
    const [userCount, setUserCount] = useState(null);
    const [postCount, setPostCount] = useState(null);
    const [reportedCount, setReportedCount] = useState(null);
    const [violationCount, setViolationCount] = useState(null);

    useEffect(() => {
        const unsubscribeUsers = onSnapshot(collection(db, 'users'), (snapshot) => {
            setUserCount(snapshot.size);
        });
        const unsubscribePosts = onSnapshot(collection(db, 'posts'), (snapshot) => {
            setPostCount(snapshot.size);
        });
        const unsubscribeReported = onSnapshot(collection(db, 'reported'), (snapshot) => {
            setReportedCount(snapshot.size);
        });
        const unsubscribeViolations = onSnapshot(collection(db, 'violations'), (snapshot) => {
            setViolationCount(snapshot.size);
        });

        return () => {
            unsubscribeUsers();
            unsubscribePosts();
            unsubscribeReported();
            unsubscribeViolations();
        };
    }, []);

    return (
        <div className="apps-section">
            <div className="stats-grid">
                <div className="stat-card">
                    <h3>Users</h3>
                    <p>{userCount !== null ? userCount : 'Loading...'}</p>
                </div>
                <div className="stat-card">
                    <h3>Posts</h3>
                    <p>{postCount !== null ? postCount : 'Loading...'}</p>
                </div>
                <div className="stat-card">
                    <h3>Reported</h3>
                    <p>{reportedCount !== null ? reportedCount : 'Loading...'}</p>
                </div>
                <div className="stat-card">
                    <h3>Violations</h3>
                    <p>{violationCount !== null ? violationCount : 'Loading...'}</p>
                </div>
            </div>
        </div>
    );
}

export default VoidStats;
